export default __webpack_public_path__ + "static/media/Carousel.4700749f.svg";